import React, { Component } from "react";
import { connect } from "react-redux";
import { createNol } from "../../../actions/masters/natureOfLossActions";
import { Link } from "react-router-dom";
import NatureOfLossForm from "./NatureOfLossForm";
import history from "../../../history";

class NatureOfLossCreate extends Component {
  onSubmit = (formValues) => {
    this.props.createNol(formValues);
  };

  render() {
    return (
      <div className="BodyInContainer">
        <div className="d-block clearfix">
          <div className="Header-Content float-start">
            <h3 className="pageMainTitle">Add a Nature Of Loss</h3>
          </div>
          <div className="float-end mt-15">
            <Link
              className="float-end cardBackBtn"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </Link>
          </div>
        </div>
        <NatureOfLossForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}
export default connect(null, { createNol })(NatureOfLossCreate);
